import * as React from 'react'
import LazyLoad, { LazyLoadProps } from 'react-lazyload'

import ui from '../../../common/constants/ui'

interface IProps extends LazyLoadProps {
  disabled?: boolean
}

const EnhancedLazyLoad = ({
  disabled,
  children,
  once = true,
  height = '100%',
  offset = ui.lazyLoadOffset,
  ...rest
}: IProps) => {
  if (disabled || !children) {
    return children ? children : null
  }

  return (
    <LazyLoad
      once={once}
      height={height}
      debounce={true}
      offset={offset}
      {...rest}
    >
      {children}
    </LazyLoad>
  )
}

export default EnhancedLazyLoad
